import { useCallback } from 'react';
import {
    useAddLogbookEntryMutation,
    useGetLogbookEntriesQuery,
    useGetSuggestedlogQuery,
    useGetTracklogByIdQuery,
} from 'ff/debrief/features/TracklogApi';
import { LogbookEntry } from 'shared/sharedTypes/logbook/LogbookEntryModels';
import { useParams } from 'react-router';

export const useCurrentLogbook = () => {
    const params = useParams<{ tracklogId: string }>();
    const selectedTracklogId = params.tracklogId;
    const { data: tracklog } = useGetTracklogByIdQuery(selectedTracklogId, {
        skip: !selectedTracklogId,
    });

    const {
        data: suggestedItems = [],
        isLoading: isSuggestedLoading,
        refetch: logbookSuggestedRefetch,
    } = useGetSuggestedlogQuery(tracklog?.trackUuid);

    const {
        data: logbookEntriesResponse,
        isLoading: isLogbookLoading,
        isError: isLogbookEntriesError,
        refetch: logbookEntriesRefetch,
    } = useGetLogbookEntriesQuery();

    const [
        addLogbookEntry,
        {
            isLoading: isEntryLoading,
            isSuccess: isEntrySuccess,
            reset: entryReset,
        },
    ] = useAddLogbookEntryMutation();

    const logbookEntries: LogbookEntry[] = logbookEntriesResponse ?? [];

    const isLogbookAssociated = useCallback(
        (logbookId: string): boolean =>
            tracklog?.logbookAssociationDetails?.some(
                assoc => assoc.logbookEntryID === logbookId
            ),
        [tracklog?.logbookAssociationDetails]
    );

    const refreshList = useCallback(() => {
        logbookSuggestedRefetch();
        logbookEntriesRefetch();
    }, [logbookSuggestedRefetch, logbookEntriesRefetch]);

    return {
        suggestedItems,
        logbookEntries,
        isSuggestedLoading,
        isLogbookLoading,
        isLogbookEntriesError,
        isLogbookAssociated,
        refreshList,
        addLogbookEntry,
        isEntryLoading,
        isEntrySuccess,
        entryReset,
    };
};
